import { initContract } from "@ts-rest/core";
import { z } from "zod";

import {
  PredictionFeedbackCauseSchema,
  PredictionFeedbackSchema,
  SimilarPartFeedbackSchema,
} from "../generated/prisma/zod";

const c = initContract();

const predictionFeedbackBody = z.object({
  rating: z.number().int().min(-1).max(1),
  comment: z.string().optional(),
  causes: z.array(PredictionFeedbackCauseSchema).optional(),
  actualMaterialPrice: z.number().nonnegative().optional(),
  actualAddedValuePrice: z.number().nonnegative().optional(),
  actualTotalPrice: z.number().nonnegative().optional(),
});

export const SimilarPartFeedbackRatingSchema = z.union([z.literal(1), z.literal(-1)]);

export type SimilarPartFeedbackRating = z.infer<typeof SimilarPartFeedbackRatingSchema>;

export const feedbackContract = c.router({
  createPredictionFeedback: {
    method: "POST",
    path: "/feedback/predictions/:predictionId",
    body: predictionFeedbackBody,
    responses: {
      201: PredictionFeedbackSchema,
    },
  },

  updatePredictionFeedback: {
    method: "PATCH",
    path: "/feedback/predictions/:feedbackId",
    body: predictionFeedbackBody,
    responses: {
      200: PredictionFeedbackSchema,
    },
  },

  getUserPredictionFeedback: {
    method: "GET",
    path: "/feedback/predictions/:predictionId/user",
    responses: {
      200: PredictionFeedbackSchema.nullable(),
    },
  },

  createSimilarPartFeedback: {
    method: "POST",
    path: "/feedback/similar-parts",
    body: z.object({
      sourcePartId: z.string().uuid(),
      targetPartId: z.string().uuid(),
      rating: SimilarPartFeedbackRatingSchema,
      index: z.number().int(),
    }),
    responses: {
      201: SimilarPartFeedbackSchema,
    },
  },

  updateSimilarPartFeedback: {
    method: "PATCH",
    path: "/feedback/similar-parts/:feedbackId",
    body: z.object({
      rating: SimilarPartFeedbackRatingSchema,
      index: z.number().int(),
    }),
    responses: {
      200: SimilarPartFeedbackSchema,
    },
  },

  deleteSimilarPartFeedback: {
    method: "DELETE",
    path: "/feedback/similar-parts/:feedbackId",
    body: z.object({}).optional(),
    responses: {
      200: SimilarPartFeedbackSchema,
    },
  },

  getUserSimilarPartFeedbacks: {
    method: "GET",
    path: "/feedback/similar-parts",
    query: z.object({
      sourcePartId: z.string().uuid(),
    }),
    responses: {
      200: SimilarPartFeedbackSchema.array(),
    },
  },
});
